var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-section',{attrs:{"title":_vm.$t('ProfileDevices_Title')}},[_c('rest-cards',{attrs:{"fetch-endpoint":_vm.fetchEndpoint,"empty-text":_vm.$t('ProfileDevices_Text_NoData')},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('device-preview-card',{attrs:{"device":item}})]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-faee41b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/profiles/pages/ProfileDevicesPage.vue
// module id = null
// module chunks = 